import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { eps } from './url.service'
import { EmployeeRequest } from '../store/employee-request/employee-request.state'
import { Observable } from 'rxjs'

@Injectable({
  providedIn: 'root'
})
export class EmployeeRequestService {
  private apiUrl = eps.user.employeeRequestApi

  constructor(private http: HttpClient) {}

  submitRegularizedAttendance(data: any) {
    return this.http.post(`${this.apiUrl}`, data)
  }

  getEmployeeRequests(
    params: string | null,
    page: number | null | undefined,
    limit: number | null | undefined
  ): Observable<{ totalCount: number; empRequests: EmployeeRequest[] }> {
    const url = params
      ? `${this.apiUrl}?${params}&page=${page}&limit=${limit}`
      : `${this.apiUrl}?page=${page}&limit=${limit}`
    return this.http.get<{ totalCount: number; empRequests: EmployeeRequest[] }>(url)
  }

  createEmployeeRequest(payload: any): Observable<any> {
    // const formData = new FormData()
    // formData.append('businessName', business.businessName)
    // formData.append('website', business.website)
    // formData.append('userId', business.userId)
    return this.http.post(`${this.apiUrl}`, payload)
  }

  updateEmployeeRequest(id: string, payload: any): Observable<EmployeeRequest> {
    return this.http.put<EmployeeRequest>(`${this.apiUrl}/${id}`, payload)
  }
}
